import { BusinessUnitEmailContactItemComponentBase } from './business-unit-email-contact-item.component.base';
import { Component, ElementRef, Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, emailValidator, requiredValidator, UserStorage } from '@scisys-uim/uim-common';
import { BusinessUnitEmailContactService, BusinessUnitService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-business-unit-email-contact-item',
  templateUrl: './business-unit-email-contact-item.component.html',
  styleUrls: ['./business-unit-email-contact-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class BusinessUnitEmailContactItemComponent extends BusinessUnitEmailContactItemComponentBase {

  constructor(protected businessUnitEmailContactService: BusinessUnitEmailContactService,
    protected businessUnitService: BusinessUnitService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(businessUnitEmailContactService, businessUnitService, refCodeStorage, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.businessUnitLoadSelectionList();
    this.addrTypeLoadSelectionList();
  }
    
  itemSet() {
    super.itemSet();
  }

  createForm(): FormGroup {
    const form = super.createForm();
    form.controls.email.setValidators([requiredValidator, emailValidator]);
    return form;
  }
  
  setDefaultDisabledFields() {
    super.setDefaultDisabledFields();
    if (!this.form) {
      return;
    }
    this.businessUnitEmailContactId?.disable();
    this.createdBy?.disable();
    this.createdDate?.disable();
    this.updatedBy?.disable();
    this.updatedDate?.disable();
  }
  
}





